<template>
  <div
    class="first-screen"
    v-if="isPC"
    data-position="1"
    data-name="头图"
    v-animate
  >
    <div class="mt80">
      <img class="wd280" :src="$IMAGE_HOST + originOS6" alt="originOS6" />
    </div>
    <div class="phone-module">
      <PlusImage class="fs1" :src="FIRST_SCREEN.fs1" alt="" />
      <PlusImage class="fs2" :src="FIRST_SCREEN.fs2" alt="" /> 
      <PlusImage class="fs3" :src="FIRST_SCREEN.fs3" alt="" />
      <!-- <video
        muted
        autoplay
        :src="VIDEOS.screenOff"
      ></video> -->
      <PlusImage class="fs4" :src="FIRST_SCREEN.fs4" alt="" />
      <PlusImage class="fs5" :src="FIRST_SCREEN.fs5" alt="" />
    </div>
  </div>
  <div
    class="first-screen"
    v-else-if="isPad"
    data-position="1"
    data-name="头图"
    v-animate
  >
    <div class="mt80">
      <img class="wd280" :src="$IMAGE_HOST + originOS6" alt="originOS6" />
    </div>
    <div class="phone-module">
      <PlusImage class="fs1" :src="FIRST_SCREEN.fs_676_1" alt="" />
      <PlusImage class="fs2" :src="FIRST_SCREEN.fs_676_2" alt="" />
      <PlusImage class="fs3" :src="FIRST_SCREEN.fs_676_3" alt="" />
      <PlusImage class="fs4" :src="FIRST_SCREEN.fs_676_4" alt="" />
      <PlusImage class="fs5" :src="FIRST_SCREEN.fs_676_5" alt="" />
    </div>
  </div>
  <div class="first-screen" v-else data-position="1" data-name="头图" v-animate>
    <img class="wd140" :src="$IMAGE_HOST + originOS6" alt="originOS6" />
    <PlusImage class="fs-360-bg" :src="FIRST_SCREEN.fs360bg" alt="" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { FIRST_SCREEN } from "@/config/image.js";
// import VIDEOS from "@/config/video.js";
import { initExposureTrack } from "@/utils/track.js";
import originOS6 from "@/assets/originOS6.svg";

export default {
  name: "FirstScreen",
  data() {
    return {
      FIRST_SCREEN,
      originOS6,
      // VIDEOS
    };
  },
  computed: {
    ...mapGetters(["isMobile", "isPad", "isPC"]),
  },
  mounted() {
    initExposureTrack(".first-screen")();
  },
};
</script>

<style scoped lang="scss">
.isPC.vp-head-fixed-flag {
  .first-screen {
    padding-top: 86px;
    height: calc(45.83333vw + 86px) !important;
  }
}
.first-screen {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #e2ebf8 100%);
  overflow: hidden;
  font-size: 0;
  height: 880 * $px1920vw + vw; // 固定header
  width: 100%;
  display: flow-root;
  position: relative;
  .wd280 {
    width: 280 * $px1920vw + vw;
  }
  .phone-module {
    position: relative;
    margin-top: 64 * $px1920vw + vw;
    width: 100%;
    img,
    picture {
      position: absolute;
      width: 252 * $px1920vw + vw;
      height: auto;
      > img {
        width: 100%;
      }
    }
    .fs1 {
      top: 0;
      left: 400 * $px1920vw + vw;
    }
    .fs2 {
      top: 40 * $px1920vw + vw;
      left: 630 * $px1920vw + vw;
    }
    .fs3 {
      top: 0;
      left: 860 * $px1920vw + vw;
      z-index: 2;
    }
    .fs4 {
      top: 40 * $px1920vw + vw;
      left: 1090 * $px1920vw + vw;
    }
    .fs5 {
      top: 0;
      left: 1320 * $px1920vw + vw;
    }
    video {
      position: absolute;
      width: 198 * $px1920vw + vw;
      height: 410 * $px1920vw + vw;
      z-index: 1;
      top: 3 * $px1920vw + vw;
      left: 860 * $px1920vw + vw;
      border-radius: 30 * $px1920vw + vw;
    }
  }
}
.isPad {
  .first-screen {
    height: 500 * $px676vw + vw;
    .mt80 {
      margin-top: 55 * $px676vw + vw;
    }
    .wd280 {
      width: 174 * $px676vw + vw;
    }
    .phone-module {
      margin-top: 57.63 * $px676vw + vw;
      img,
      picture {
        width: 136 * $px676vw + vw;
      }
      .fs1 {
        left: 42 * $px676vw + vw;
      }
      .fs2 {
        top: 27 * $px676vw + vw;
        left: 163 * $px676vw + vw;
      }
      .fs3 {
        left: 285 * $px676vw + vw;
      }
      .fs4 {
        top: 27 * $px676vw + vw;
        left: 406 * $px676vw + vw;
      }
      .fs5 {
        left: 527 * $px676vw + vw;
      }
    }
  }
}
.isMobile {
  .first-screen {
    background: unset;
    height: 500 * $px360vw + vw;
    .wd140 {
      width: 140 * $px360vw + vw;
      margin: 52 * $px360vw + vw auto 0;
    }
    .fs-360-bg {
      position: absolute;
      width: 100%;
      height: auto;
      bottom: 0;
      left: 0;
      z-index: -1;
    }
  }
}

@media (prefers-color-scheme: dark) {
  .isPad {
    .first-screen {
      background: linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, #e2ebf8 100%);
    }
  }
}
</style>
